import React from 'react';
import { TextField } from './TextField';

// A number input that keeps the empty string as a distinct state rather than coercing it to 0.
//
// That distinction matters here: in the score-spec schema an OMITTED `latest_n` means "every
// matching document" while `latest_n: 1` means one. Coercing empty to zero would silently
// author a rule the loader rejects, and coercing it to 1 would silently change what the model
// reads. `onChange` receives `null` for empty and a Number otherwise.

export const NumberField = ({ value, onChange, min, max, step, ...rest }) => (
  <TextField
    type="number"
    inputMode="numeric"
    min={min}
    max={max}
    step={step}
    value={value === undefined || value === null ? '' : value}
    onChange={(next) => {
      if (!onChange) return;
      if (next === '') {
        onChange(null);
        return;
      }
      const parsed = Number(next);
      onChange(Number.isNaN(parsed) ? null : parsed);
    }}
    {...rest}
  />
);
